<template>
<div style="height: 100%;width: 100%;overflow: auto">
  <el-form ref="updateForm" :model="busData" :rules="rules" label-width="150px" style="margin: 20px" >
    <el-row>
      <el-col :span="22">
        <el-form-item label="部门：" prop="department_id">
          <el-cascader :props="deptProp" :options="deptList"
                       :show-all-levels="false" placeholder="请选择" v-model="busData.department_id"
                       filterable/>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="busData.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="性别：" prop="sex">
          <el-select v-model="busData.sex">
            <el-option label="男" key="male" value="male"></el-option>
            <el-option label="女" key="female" value="female"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="职位：" prop="position">
          <el-cascader :props="props" :options="positionList" style="width: 200px"
                       :show-all-levels="false" placeholder="请选择" v-model="busData.position"
                       clearable filterable/>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="业务关键人：" prop="business_key">
          <el-select v-model="busData.business_key">
            <el-option label="是" key="true" value="true"></el-option>
            <el-option label="否" key="false" value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="在职状态：" prop="status">
          <el-select v-model="busData.status">
            <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="入职年份：" prop="employment_year">
          <el-input v-model="busData.employment_year"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="离职年份：">
          <el-input v-model="busData.resignation_year"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="企业邮箱：">
          <el-input v-model="busData.mailbox"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="22">
        <el-form-item label="电话：">
          <el-input  v-model="busData.phone" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="22">
        <el-form-item label="联系方式：" >
          <div>
            <div v-for="item in busData.phoneList"  style="display:flex;margin-bottom: 10px;align-items: center">
              <el-input v-model="item.phone" placeholder="号码" style="width: 200px"></el-input>
              <el-select style="margin-left: 10px;width: 150px" placeholder="号码类型" v-model="item.type">
                <el-option :key="'phone'" :value="'phone'" :label="'电话'">电话</el-option>
                <el-option :key="'work'" :value="'work'" :label="'办公'">办公</el-option>
                <el-option :key="'other'" :value="'other'" :label="'其它'">其它</el-option>
              </el-select>
              <div style="margin-left: 10px; line-height: 20px;cursor: pointer;" @click="addLine">
              <el-icon><Plus /></el-icon>
              </div>
              <div style="margin-left: 20px; line-height: 20px;cursor: pointer; " @click="delLine(item)">
              <el-icon><Minus /></el-icon>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="22">
        <el-form-item label="备注：">
          <el-input type="textarea" rows="3" v-model="busData.remark"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="照片/微信头像：">
          <KfImageUpload v-model:init-file="wechat_img_file" :limit="1" @fileChange="setWechatImageId"></KfImageUpload>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item label="联系人资料截图：">
          <KfImageUpload v-model:init-file="contact_info_img_file" :limit="1" @fileChange="setContactImageId"></KfImageUpload>
        </el-form-item>
      </el-col>
      <el-col :span="22">
        <el-form-item label="名片正反面：">
          <KfImageUpload v-model:init-file="calling_card_file" :limit="2" @fileChange="setCallingImageId"></KfImageUpload>
        </el-form-item>
      </el-col>
      <el-col  :span="22">
        <el-form-item label="" >
          <el-button @click="update">保存</el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</div>
</template>

<script>
import {Minus, Plus} from "@element-plus/icons-vue";
import {nanoid} from "nanoid";

export default {
  name: "CompanyContactUpdate",
  components: {Minus, Plus},
  inject: ['$fn'],

  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data(){
    return {
      busData:{
        phoneList:[]
      },
      positionList:[],
      wechat_img_file:[],
      contact_info_img_file:[],
      calling_card_file:[],
      deptList:[],
      deptProp:{
        checkStrictly:true,
        emitPath:false,
        expandTrigger:'hover',
        value: 'id',
        label: 'name'
      },
      props: {
        emitPath:false,
        expandTrigger:'hover',
        value: 'id',
        label: 'position'
      },
      rules: {
        department_id: [{required: true, message: '请选择部门', trigger: 'blur'}],
        name: [{required: true, message: '请填写名称', trigger: 'blur'}],
        sex: [{required: true, message: '请选择性别', trigger: 'blur'}],
        position: [{required: true, message: '请选择职位', trigger: 'blur'}],
        business_key: [{required: true, message: '请选择是否是业务关键人', trigger: 'blur'}],
        status: [{required: true, message: '请选择在职状态', trigger: 'blur'}],
        employment_year: [{required: true, message: '请填写入职年份', trigger: 'blur'}],
      }

    }
  },
  computed: {
    statusList() {
      return this.$store.getters['core/getDictList']('user_status');
    },
  },
  created() {
    this.getPositionList();
    this.getDeptTreeData();
    this.getFormData();
  },
  methods: {
    async getFormData(){
      let params = this.parentData;
      let data = await this.$http('companyOrganization.getCompanyContactDetail',params);
      this.busData = data.busData;
      if(data.busData.business_key){
        this.busData.business_key = 'true';
      }else {
        this.busData.business_key = 'false';
      }

      if(!this.busData.phoneList || this.busData.phoneList.length === 0){
        this.busData.phoneList = [];
        this.addLine();
      }
      this.wechat_img_file = data.wechat_img_file;
      this.contact_info_img_file = data.contact_info_img_file;
      this.calling_card_file = data.calling_card_file;
    },
    update(){
      this.$refs.updateForm.validate(async valid => {
        if (!valid) {
          return this.$message.error("有必选或必填项为空");
        }
        let params = this.busData;
        //联系方式简化
        let phoneList = [];
        for (let item of this.busData.phoneList) {
          const index = this.busData.phoneList.indexOf(item) + 1;
          if (item.phone) {
            if (!item.type) {
              this.$message.error("第" + index + "行，请选择号码类型");
              return;

            }
          }
          if (item.type) {
            if (!item.phone) {
              this.$message.error("第" + index + "行，请输入号码");
              return;
            }
          }
          if (item.phone && item.type) {
            phoneList.push(item);
          }
        }
        params.phoneList = phoneList;
        this.$http('companyOrganization.updateCompanyContact', params).then(() => {
          this.$message.success("提交成功");
          this.$fn.reloadTreeData();
          this.$fn.closeWindow();
        })
      });
    },
    async getDeptTreeData(){
      let params = {company_id:this.parentData.company_id}
      this.deptList = await this.$http('companyOrganizationService.getRootTree',params);
      console.log('deptList==', this.deptList)
    },
    async getPositionList(){
      this.positionList = await this.$http('crmDsService.getContactPosition');
    },
    addLine(){
      this.busData.phoneList.push({
        id: nanoid(),
      })
    },
    delLine(itemNode){
      if(this.busData.phoneList.length === 1){
        return;
      }
      let delId = itemNode.id
      this.busData.phoneList.forEach(item => {
        if(delId === item.id){
          this.busData.phoneList.splice(this.busData.phoneList.indexOf(item),1)
        }
      })

    },
    setWechatImageId(ids){
      if (ids.length > 0) {
        this.busData.wechat_img = ids
      }
    },
    setContactImageId(ids){
      if (ids.length > 0) {
        this.busData.contact_info_img = ids
      }
    },
    setCallingImageId(ids){
      if (ids.length > 0) {
        this.busData.calling_card = ids
      }
    },
  }
}
</script>

<style scoped>

</style>